import { QueryClient } from '@tanstack/react-query';

const STALE_TIME = 10 * 60 * 1000;
const CACHE_TIME = 15 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME,
      gcTime: CACHE_TIME,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});
